import React from "react";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import {
  VERTEX360_MOBILE_APP_STORE_URL,
  VERTEX360_MOBILE_GOOGLE_PLAY_URL,
} from "Constants/constant";

const storeLinkClass =
  "flex w-full items-center justify-center gap-3 rounded-xl border border-gray-900 bg-gray-900 px-4 py-3 text-left text-white shadow-sm transition hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-dark focus:ring-offset-2 sm:min-w-[240px]";

const MobileAppDownloadLinks = () => (
  <div className="flex flex-col gap-3 sm:flex-row sm:justify-center sm:items-stretch">
    <a
      href={VERTEX360_MOBILE_APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={storeLinkClass}
      aria-label="Download Vertex360 on the App Store"
    >
      <FaApple className="h-7 w-7 shrink-0" aria-hidden="true" />
      <span className="flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-wide opacity-90">
          Download on the
        </span>
        <span className="text-sm font-semibold">App Store</span>
      </span>
    </a>
    <a
      href={VERTEX360_MOBILE_GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={storeLinkClass}
      aria-label="Get Vertex360 on Google Play"
    >
      <FaGooglePlay className="h-6 w-6 shrink-0" aria-hidden="true" />
      <span className="flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-wide opacity-90">
          Get it on
        </span>
        <span className="text-sm font-semibold">Google Play</span>
      </span>
    </a>
  </div>
);

export default MobileAppDownloadLinks;
